
import {
  Popover,
  Portal,
  Select,
  createListCollection,
  Button,
} from "@chakra-ui/react"
import { useTranslation } from "react-i18next";
import Cookies from 'js-cookie';
import { langs } from '@/config/langs';
import type { Placement } from '@floating-ui/dom';

const languages = createListCollection({
  items: langs,
  itemToValue: (item) => item.value,
})

interface LanguageSelectorProps {
  /** Optional render function for the trigger content (overrides default) */
  renderTriggerContent?: (currentLanguageLabel: string) => React.ReactNode;
  /** Popover placement, e.g., "right", "left", "top", "bottom" */
  popoverPlacement?: Placement;
  /** Offset for popover main axis, default 40 */
  popoverOffset?: number;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  renderTriggerContent,
  popoverPlacement = "right",
  popoverOffset,
}) => {
  const { i18n, t } = useTranslation(['common']);

  const langCode = i18n.language.split("-")[0];
  const currentLanguage = languages.items.find(item => item.value === langCode);
  const currentLanguageLabel = currentLanguage?.label || "English"

  return (
    <Popover.Root
      size="xs"
      positioning={{ placement: popoverPlacement, offset: { mainAxis: popoverOffset } }}
    >
      <Popover.Trigger bg="none" m="none" asChild>
        <Button variant="outline" size="sm">
          {renderTriggerContent ? (
            renderTriggerContent(currentLanguageLabel)
          ) : (
            // <Text>
            //   <HStack>Language ▼</HStack> { /* {buttonTextPrefix ? `${t(buttonTextPrefix)}: ` : ''}{currentLanguageLabel} */}
            // </Text>
            "Language ▼"
          )}
        </Button>
      </Popover.Trigger>

      <Portal>
        <Popover.Positioner>
          <Popover.Content maxW="220px" borderRadius="md" p={2} boxShadow="md">
            <Popover.Header>{t("language.popover.header")}</Popover.Header>
            <Popover.Body>
              <Select.Root
                collection={languages}
                size="sm"
                onValueChange={(details) => {
                  const value = Array.isArray(details.value) ? details.value[0] : details.value;
                  i18n.changeLanguage(value);
                  Cookies.set("language", value, { expires: 365 });
                }}
                defaultValue={[langCode]}
              >
                <Select.HiddenSelect />
                <Select.Control>
                  <Select.Trigger>
                    <Select.ValueText placeholder={t("language.popover.placeholder")} />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>
                <Select.Positioner>
                  <Select.Content>
                    {languages.items.map((item) => (
                      <Select.Item item={item} key={item.value}>
                        {item.label}
                      </Select.Item>
                    ))}
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};
